<template>
  <section v-if="experiences?.length" :id="data?.anchor_id ? data.anchor_id : null" class="experiences defaultSectionMargins" :class="{'isLocation': !isAccommodation}">
    <div class="container">
      <h2 v-text="data.title" />
  
      <p v-if="data.description" class="experiences__IntroText" v-text="data.description" />
  
      <FlickitySlider class="experiences__Slider experiencesEventsSlider" :options="flickityOptions" @ready="sliderReady">
        <div v-for="item in experiences" class="experiences__Item experiencesEventsItem">
          <a :href="item.url">{{ $t('seeDetails') }}</a>
  
          <div class="experiencesEvents__ItemImage">
            <img :src="item.image" width="420" height="315" />
            <Button medium secondary>{{ $t('seeDetails') }}</Button>
          </div>
  
          <div class="experiences__ItemContent">
            <h3 v-text="item.name" />
            <div class="experiences__ItemInfos">
              <div>
                <Icon name="clock-small" /> {{ item.duration }}h
              </div>
              <div>
                <Icon name="location" /> {{ item.location.city }}
              </div>
              <div>
                {{ $t('from') }} {{ formatPrice(item.minPrice.amount, item.minPrice.currency, lang) }}
              </div>
            </div>
            <p v-if="item.highlight" v-text="item.highlight" />
          </div>
        </div>
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });
  const { page } = usePage();
  const { lang } = useLanguage();
  const experiences = ref([]);

  const flickityOptions = {
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    cellAlign: 'left',
  };

  const isAccommodation = computed(() => page.value.meta?.type.includes('AccommodationDetail'));
  const queryPageId = computed(() => useRoute().query?.pageId);

  try {
    const response = await useServerFetch(`experience/experiences?${ isAccommodation.value || queryPageId?.value ? 'accommodation' : 'location' }=${ queryPageId?.value ? queryPageId.value : page.value.id }`, {
      method: 'GET',
    })

    if (response.experiences) experiences.value = response.experiences;
  } catch(error) {
    console.log(error)
  }

  function sliderReady(slider) {
    setTimeout(() => {
      slider.resize();
    }, 500);
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_experiences.scss');
</style>